import * as React from "react";
import * as _ from "lodash";
import { connect, Dispatch } from "react-redux";
import { Button, FormControl, Checkbox, FormGroup, Alert, Well } from "react-bootstrap";
import { IApplicationState, AppActionCreators, RecipientActionCreators } from "../../../../store/index";
import { IBaseResponse } from '../../../../models/index';
import UploadFile from './upload-file'
import { FilterWrapper } from "@nkr/views/admin/center/list/styles";


interface IOwnProps {
    centerId: number
}
interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    parseFile: (starFile: File, centerId: number, deleteNotInFile: boolean) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    waitListFile: File,
    deleteNotInFile: boolean,
    displayResultAlert: boolean,
    resultMessage: string,
    isResultSuccess: boolean
}

class WaitlistUploadForm extends React.Component<TProps, IState> {
    readonly state: IState = {
        waitListFile: null,
        deleteNotInFile: false,
        displayResultAlert: false,
        resultMessage: "",
        isResultSuccess: false
    }

    componentDidMount =()=> {
        this.getData();
    }
    getData = () => {
        
    }
    handleButtonClick = () => {

        this.props.showLoading("Parsing File...").then(() => {
            var file: File = this.state.waitListFile;
            var deleteNotInFile: boolean = this.state.deleteNotInFile;
            var centerId: number = this.props.centerId;

            //validate file
            if(file == null || file.name.length == 0 || (file.name.indexOf(".csv") == -1 && file.name.indexOf(".txt")))
            {
                this.setState({
                    displayResultAlert: true,
                    resultMessage: "Invalid file type: please select a file",
                    isResultSuccess: false

                });
                this.props.hideLoading();
                return;

            }

            this.props.parseFile(file, centerId, deleteNotInFile).then((response: IBaseResponse) => {
                if (response.data.success) {
                    this.setState({
                        displayResultAlert: true,
                        resultMessage: "Processing successfully complete",
                        isResultSuccess: true
                    });
                }
                else {
                    this.setState({
                        displayResultAlert: true,
                        resultMessage: "An error occurred",
                        isResultSuccess: false
                    });
                }
                this.props.hideLoading();
            }).catch((ex: string) => {

                this.setState({
                    displayResultAlert: true,
                    resultMessage: "An error occured.  Please check console for more details",
                    isResultSuccess: false
                });

                this.props.hideLoading();
            })
        }).catch((ex) => {

            this.setState({
                displayResultAlert: true,
                resultMessage: "An error occured: " + ex.message,
                isResultSuccess: false
            });

            this.props.hideLoading();
        });

    }

    handleFileSelect = (file: File) => {
        this.setState({
            waitListFile: file
        })
    }

    handleDeleteNotInFile = () => {
        this.setState({
            deleteNotInFile: !this.state.deleteNotInFile
        });
    }

    renderAlert = () => {
        var style = this.state.isResultSuccess ? "success" : "danger";
        return (
            <Alert bsStyle={style}>
                {this.state.resultMessage }
            </Alert>
        )

    }

    render = () => {
        var waitListFileName = "";
        if (this.state.waitListFile != null) {
            waitListFileName = this.state.waitListFile.name;
        }
        var hasWaitListFile = waitListFileName != "";
        
        return (
            <>
            <div className="col-md-12">
            { this.state.displayResultAlert && (this.renderAlert()) }
                
            { /*  Upload button  */}
                <div className="row">
                    <FormGroup>
                        <UploadFile elementName="waitListFile" 
                            valid={true} 
                            disable={false} 
                            onSelectFile={this.handleFileSelect} />

                        {hasWaitListFile && (<Well bsSize="small" 
                                                    style={{display: 'inline', marginLeft: 2 }}>
                                                {waitListFileName}
                                            </Well>)}
                        {!hasWaitListFile && (<Well bsSize="small" 
                                                    style={{display: 'inline', marginLeft: 2 }}>
                                                No File Chosen
                                            </Well>)}
                    </FormGroup>
                </div>
                
                <FormGroup>
                    <Checkbox style={{ marginTop: 5 }} checked={this.state.deleteNotInFile} onClick={this.handleDeleteNotInFile}>
                       Clear Waitlist Records
                    </Checkbox>
                </FormGroup>

                <Button onClick={this.handleButtonClick}>Upload Waitlist</Button>
            </div>
            </>
        )
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        registrationSteps: appState.registrationSteps
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {

    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        parseFile: (starFile: File, centerId: number, deleteNotInFile:boolean): Promise<IBaseResponse> => { return dispatch(RecipientActionCreators.parseWaitListFile(starFile, centerId, deleteNotInFile));}
    };
}


export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(WaitlistUploadForm);